import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { showAppToast } from '@/components/AppToaster'

interface AlertPayload {
  success?: string
  error?: string
  info?: string
}

interface StateWithAlert {
  alert: AlertPayload | null
}

export default function Alert(): null {
  const alert = useSelector((state: StateWithAlert) => state.alert)

  useEffect(() => {
    if (alert == null) return

    const errorText =
      alert.error === 'The security token included in the request is expired'
        ? 'Your session has expired. Please refresh the page and try again.'
        : alert.error

    if (typeof alert.success !== 'undefined') {
      showAppToast('success', alert.success, 5000)
    } else if (typeof alert.error !== 'undefined') {
      showAppToast('error', errorText, 10000)
      console.error('Toast displayed an error', errorText)
    } else if (typeof alert.info !== 'undefined') {
      showAppToast('info', alert.info, 10000)
    } else {
      console.error(
        'Invalid alert type. Please check your alert configuration',
        alert
      )
    }
  }, [alert])

  return null
}
